import { countries as countryDataCountries } from 'country-data-list';

export type countryItem = {
  /** The code representing a country */
  countryCode: string;
  /** The readable name for a country */
  name: string;
};

/** Filters list of countries name and normalises the data do be consumed */
export const countries: countryItem[] = countryDataCountries.all
  .reduce((_countries, country) => {
    if (
      !_countries.find((_country) => _country.countryCode === country.alpha2) &&
      country.status === 'assigned'
    ) {
      _countries.push({
        countryCode: country.alpha2,
        name: country.name,
      });
    }

    return _countries;
  }, [] as countryItem[])
  .sort((a, b) => a.name.localeCompare(b.name));
